import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { ApiConstants } from '../constants/api.constants';
import { CookiesHandlerService } from './cookies-handler.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    contactDetails;
    userAuthenticated;

    constructor(
        private http: HttpClient,
        private cookies: CookieService,
        private cookiesHandler: CookiesHandlerService
    ) {}

    storeUserAuthenticationStatus(status) {
        if (status) {
            this.userAuthenticated = true;
        } else if (!status) {
            this.userAuthenticated = false;
        }
    }

    isUserAuthenticated() {
        return this.userAuthenticated;
    }

    logout() {
        const showConfirmation = localStorage.getItem('isShowConfirmation');
        localStorage.clear();
        localStorage.setItem('isShowConfirmation', showConfirmation);

        this.logoutTrackApi('LOGOUT').subscribe({
            next: () => {
                this.cookiesHandler.clearCookiesOnLogout();
                this.userAuthenticated = false;
                if (environment.production) {
                    this.prodLogOut();
                } else if (environment.preproduction) {
                    this.preprodLogOut();
                } else {
                    this.devLogOut();
                }
            },
            error: () => {
                this.cookiesHandler.clearCookiesOnLogout();
                this.userAuthenticated = false;
                if (environment.production) {
                    this.prodLogOut();
                } else if (environment.preproduction) {
                    this.preprodLogOut();
                } else {
                    this.devLogOut();
                }
            }
        });
    }

    prodLogOut() {
        this.logoutApi().subscribe(() => {
            window.location.href = environment.prefix + '/';
        });
    }

    preprodLogOut() {
        window.location.href = 'http://10.23.96.21:9062/realms/Tuwaiq/protocol/openid-connect/logout?redirect_uri=https://tuwaiqpreprod.stc.com.sa';
    }

    devLogOut() {
        window.location.href = 'https://tuwaiqdev.verify.ibm.com/idaas/mtfim/sps/idaas/logout';
    }

    logoutApi() {
        const api = ApiConstants.LOGOUT;
        return this.http.get(api);
    }

    logoutTrackApi(reason: string) {
        let params = new HttpParams();
        params = params.append('reason', reason);

        const api = ApiConstants.LOGOUT_TRACK;
        return this.http.post(
            api,
            {},
            {
                params: params,
                withCredentials: true
            }
        );
    }
}
